// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b1fdd3fa","801":"d4170f35"}[chunkId] + ".chunk.js";
};